import React from 'react';
import { cn } from '../../../utils/formatter';

export const HOLIDAY_COLORS = {
  NACIONAL: {
    bg: 'bg-red-100 dark:bg-red-900/30',
    border: 'border-red-500',
    text: 'text-red-700 dark:text-red-400',
    dot: 'bg-red-500'
  },
  ESTADUAL: {
    bg: 'bg-green-100 dark:bg-green-900/30',
    border: 'border-green-500',
    text: 'text-green-700 dark:text-green-400',
    dot: 'bg-green-500'
  },
  MUNICIPAL: {
    bg: 'bg-yellow-100 dark:bg-yellow-900/30',
    border: 'border-yellow-500',
    text: 'text-yellow-700 dark:text-yellow-400',
    dot: 'bg-yellow-500'
  },
  FOLGA: {
    bg: 'bg-blue-100 dark:bg-blue-900/30',
    border: 'border-blue-500',
    text: 'text-blue-700 dark:text-blue-400',
    dot: 'bg-blue-500'
  }
};

export const DEMAND_COLORS = {
  bg: 'bg-orange-100 dark:bg-orange-900/30',
  border: 'border-orange-500',
  text: 'text-orange-700 dark:text-orange-400',
  dot: 'bg-orange-500'
};

const HOLIDAY_LABELS = {
  NACIONAL: 'Nacional',
  ESTADUAL: 'Estadual',
  MUNICIPAL: 'Municipal',
  FOLGA: 'Folga'
};

export const LegendPanel: React.FC = () => {
  return (
    <div className="bg-white dark:bg-neutral-800 rounded-lg border border-gray-200 dark:border-neutral-700 p-4">
      <h3 className="text-sm font-semibold text-gray-900 dark:text-white mb-3">
        Legenda
      </h3>
      
      <div className="space-y-2">
        {/* Holiday types */}
        <div className="space-y-1.5">
          <p className="text-xs font-medium text-gray-600 dark:text-gray-400 mb-1">
            Tipos de Feriado
          </p>
          {Object.entries(HOLIDAY_LABELS).map(([tipo, label]) => (
            <div key={tipo} className="flex items-center gap-2">
              <div className={cn(
                'w-3 h-3 rounded-full',
                HOLIDAY_COLORS[tipo as keyof typeof HOLIDAY_COLORS].dot
              )} />
              <span className="text-xs text-gray-700 dark:text-gray-300">
                {label}
              </span>
            </div>
          ))}
        </div>

        {/* Demand */}
        <div className="pt-2 border-t border-gray-200 dark:border-neutral-700">
          <p className="text-xs font-medium text-gray-600 dark:text-gray-400 mb-1.5">
            Outros
          </p>
          <div className="flex items-center gap-2">
            <div className={cn('w-3 h-3 rounded-full', DEMAND_COLORS.dot)} />
            <span className="text-xs text-gray-700 dark:text-gray-300">
              Demanda para Entrega
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

